<template>
  <section
    id="development-sites"
    class="layout-pt-lg layout-pb-lg sec"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <!-- Watermark layer (kartların ALTINDA) -->
    <div class="wm-layer">
      <BlockSymbol
        v-if="vars.watermarkImage"
        :block-logo-image="String(vars.watermarkImage)"
        :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
        position-text="right_bottom"
        :company-key="company.company_key"
      />
      <BlockSymbol
        v-if="vars.watermark2Image"
        :block-logo-image="String(vars.watermark2Image)"
        block-opacity="1"
        position-text="left_top"
        :company-key="company.company_key"
      />
    </div>

    <!-- İçerik layer (kartlar) -->
    <div class="container content-layer">
      <div class="tw-mb-16">
        <h2 class="tw-text-3xl lg:tw-text-4xl">
          {{ vars.titleText || 'All Development Sites' }}
        </h2>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-8 lg:tw-grid-cols-2">
        <div v-for="(card, idx) in cards" :key="`dev-card-${idx}-${card?.title || idx}`" class="card-layer tw-w-full">
          <div class="tw-overflow-hidden">
            <LibraryImage
              :w-ratio="16"
              :h-ratio="9"
              :src="card?.photo"
              :alt="card?.title || 'site photo'"
              image-class="tw-w-full tw-h-full tw-object-cover"
            />
          </div>

          <h3 class="tw-mt-6">
            {{ card?.title || 'Development Site Name' }}
          </h3>

          <div
            v-if="card.address"
            :style="`color: var(--${vars.textColor}) !important;`"
            class="tw-mt-6 tw-flex tw-items-start tw-gap-2"
          >
            <svg width="16" height="21" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.115 21.561C7.721 22.061 8.353 22.518 9 22.964C9.6484 22.5239 10.2773 22.0558 10.885 21.561C11.898 20.7292 12.8513 19.8273 13.738 18.862C15.782 16.627 18 13.387 18 9.75C18 8.5681 17.7672 7.39778 17.3149 6.30585C16.8626 5.21392 16.1997 4.22177 15.364 3.38604C14.5282 2.55031 13.5361 1.88738 12.4442 1.43508C11.3522 0.982792 10.1819 0.75 9 0.75C7.8181 0.75 6.64778 0.982792 5.55585 1.43508C4.46392 1.88738 3.47177 2.55031 2.63604 3.38604C1.80031 4.22177 1.13738 5.21392 0.685084 6.30585C0.232792 7.39778 0 8.5681 0 9.75C0 13.387 2.218 16.626 4.262 18.862C5.14862 19.8277 6.10196 20.7289 7.115 21.561ZM9 13C8.13805 13 7.3114 12.6576 6.7019 12.0481C6.09241 11.4386 5.75 10.612 5.75 9.75C5.75 8.88805 6.09241 8.0614 6.7019 7.4519C7.3114 6.84241 8.13805 6.5 9 6.5C9.86195 6.5 10.6886 6.84241 11.2981 7.4519C11.9076 8.0614 12.25 8.88805 12.25 9.75C12.25 10.612 11.9076 11.4386 11.2981 12.0481C10.6886 12.6576 9.86195 13 9 13Z"
                fill="#66C9CF"
              />
            </svg>
            <span class="tw-leading-6">{{ card.address }}</span>
          </div>

          <div class="tw-mt-6" v-if="card.button_label">
            <button
              @click.stop="onButton(card)"
              :class="`n-${card.button_type || 'arrow'}`"
              style="color: #66c9cf !important"
            >
              {{ card.button_label }}
              <span v-if="(card.button_type || 'arrow') === 'arrow'">
                <svg width="23" height="8" viewBox="0 0 23 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.3536 4.35355C22.5488 4.15829 22.5488 3.84171 22.3536 3.64645L19.1716 0.464466C18.9763 0.269204 18.6597 0.269204 18.4645 0.464466C18.2692 0.659728 18.2692 0.976311 18.4645 1.17157L21.2929 4L18.4645 6.82843C18.2692 7.02369 18.2692 7.34027 18.4645 7.53553C18.6597 7.7308 18.9763 7.7308 19.1716 7.53553L22.3536 4.35355ZM0 4V4.5H22V4V3.5H0V4Z"
                    fill="#66C9CF"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';
import { jQuery } from 'public/theme3/js/custom';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'OurValues',
  mixins: [ComponentMixin],

  components: {
    BlockSymbol,
  },

  data() {
    return {
      isPopupVisible: false,
      visibleIndex: 0,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      renderKey: produceKey(),
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    visibleTestimonial() {
      return this.items[this.visibleIndex];
    },

    cards() {
      return this.groupedVariables.cards;
    },
  },

  methods: {
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },

    goNextOne() {
      if (this.items.length !== this.visibleIndex + 1) {
        this.visibleIndex += 1;
      } else {
        this.visibleIndex = 0;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },

    goPrevOne() {
      if (this.visibleIndex > 0) {
        this.visibleIndex -= 1;
      } else {
        this.visibleIndex = this.items.length - 1;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },
    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
});
</script>

<style scoped>
.sec {
  position: relative;
  overflow: hidden;
}

/* Watermark katmanı: her zaman içerik altında */
.wm-layer {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

/* İçerik katmanı: üstte */
.content-layer {
  position: relative;
  z-index: 2;
}
.card-layer {
  position: relative;
  z-index: 2;
}

/* BlockSymbol içindeki gerçek elemanı da ez (scoped derin seçici) */
:deep(.block) {
  z-index: 0 !important;
}
</style>
